import PermissionTooltip from '@components/PermissionTooltip';
import { CheckboxFormField } from '@elements/FormField';
import MultipleEmailField from '@elements/MultipleEmailField';
import useUrlPermission from '@hooks/url-permission';
import type { Control, FieldError, Merge } from 'react-hook-form';
import { cn } from '@skupreme/shared/ui';
import type { IEmailData } from 'types/common/email';

interface IATTNInputProps {
  control: Control<any>;
  emailLoading?: boolean;
  disableNotify?: boolean;
  emails: IEmailData[];
  helpText?: string;
  error?: FieldError | Merge<FieldError, (FieldError | undefined)[]>;
  disabled?: boolean;
  className?: string;
}

export function ATTNInput({
  control,
  emailLoading,
  disableNotify,
  emails,
  helpText,
  error,
  disabled: attnDisabled = false,
  className = '',
}: IATTNInputProps) {
  const { disabled, hidden } = useUrlPermission();
  return (
    <div className={cn('sk:flex', className)}>
      <div className="sk:mr-3 sk:min-w-0 sk:flex-1">
        <PermissionTooltip
          disabled={disabled}
          hidden={hidden}
          position="bottom center"
        >
          <MultipleEmailField
            loading={emailLoading}
            emails={emails}
            control={control}
            name="email_addresses"
            text="Attention"
            defaultValue={[]}
            required
            helpText={helpText}
            error={!!error}
            disabled={attnDisabled || disabled}
          />
        </PermissionTooltip>
      </div>
      <div className="sk:flex sk:flex-col">
        <PermissionTooltip
          disabled={disabled}
          hidden={hidden}
          position="bottom right"
        >
          <CheckboxFormField
            label="Notify"
            name="notify"
            defaultValue={false}
            control={control}
            labelClass="sk:pb-2!"
            fieldClass="sk:mb-0! large-checkbox"
            disabled={disableNotify || disabled}
          />
        </PermissionTooltip>
      </div>
    </div>
  );
}
